import { ChangeAreaComponent } from "./change-area/change-area.component"
import { DetailComponent } from "./detail/detail.component"
import { DocumentTagComponent } from "./document-tag/document-tag.component"
import { EditableDetailComponent } from "./editable-detail/editable-detail.component"
import { FloatingButtonComponent } from "./floating-button/floating-button.component"
import { HeaderComponent } from "./header/header.component"
import { ManagementListComponent } from "./management-list/management-list.component"
import { NotificationsComponent } from "./notifications/notifications.component"
import { PaginationComponent } from "./pagination/pagination.component"
import { PushNotificationsComponent } from "./push-notifications/push-notifications.component"
import { SidebarComponent } from "./sidebar/sidebar.component"
import { WizardStepButtonsComponent } from "./wizard-step-buttons/wizard-step-buttons.component"
import { inputs, standaloneInputs } from "./input"
import { OperationProgressComponent } from "./operation-progress/operation-progress.component"
import { WarningBadgeComponent } from "./warning-badge/warning-badge.component"
import { modals } from "./modals"
import { ModalConfirmationComponent } from "./modals/modal-confirmation/modal-confirmation.component"
import { ModalNotificationSettingsComponent } from "./modals/modal-notification-settings/modal-notification-settings.component"
import { userProfileComponents } from "./user-profile"

export {
  ChangeAreaComponent,
  DetailComponent,
  DocumentTagComponent,
  EditableDetailComponent,
  FloatingButtonComponent,
  HeaderComponent,
  ManagementListComponent,
  NotificationsComponent,
  PaginationComponent,
  PushNotificationsComponent,
  SidebarComponent,
  WizardStepButtonsComponent,
  OperationProgressComponent,
  WarningBadgeComponent,
}

import { ColumnFilterComponent } from './column-filter/column-filter.component';
import { DriverSelectComponent } from './driver-select/driver-select.component';
import { FilterPanelComponent } from './filter-panel/filter-panel.component';
import { FilterReceiversComponent } from './filter-panel/filter-receivers/filter-receivers.component';
import { VehicleSelectComponent } from './vehicle-select/vehicle-select.component';
import { Select2OptionComponent } from './select2-option/select2-option.component';
import { FormActionsComponent } from './form-actions/form-actions.component';
import { UtcDateTimePipe } from './utc-date-time/utc-date-time.pipe';

export const sharedComponents = [
  ChangeAreaComponent,
  ColumnFilterComponent,
  DriverSelectComponent,
  VehicleSelectComponent,
  DocumentTagComponent,
  EditableDetailComponent,
  FloatingButtonComponent,
  HeaderComponent,
  ...inputs,
  ...modals,
  NotificationsComponent,
  PushNotificationsComponent,
  SidebarComponent,
  WizardStepButtonsComponent,
  ...userProfileComponents
]

export const standaloneSharedComponents = [
  DetailComponent,
  FormActionsComponent,
  FilterPanelComponent,
  FilterReceiversComponent,
  ...standaloneInputs,
  ModalConfirmationComponent,
  ModalNotificationSettingsComponent,
  PaginationComponent,
  Select2OptionComponent,
  UtcDateTimePipe,
]
